import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import {
    addMonths,
    addWeeks,
    format,
    getWeek,
    Locale,
    startOfDay,
    subMonths,
    subWeeks,
} from 'date-fns'
import { FC } from 'react'
import { StepperCalendar } from './StepperCalendar'
import { SwitcherCalendar } from './SwitcherCalendar'

type Props = {
    displayWeekCalendar: boolean
    currentMonth: Date
    selectedDate: Date
    locale?: Locale
    onChangeWeek: (newWeek: number) => void
    onChangeMonth: (newDate: Date) => void
    onChangeCalendarView: (isWeek: boolean) => void
    onSelectDate: (newDate: Date) => void
}

export const Header: FC<Props> = ({
    displayWeekCalendar,
    currentMonth,
    locale,
    onChangeMonth,
    onChangeWeek,
    onChangeCalendarView,
    onSelectDate,
}) => {
    const { breakpoints } = useTheme()

    const isMobile = useMediaQuery(breakpoints.down('md'))

    const handleNext = () => {
        if (displayWeekCalendar) {
            onChangeMonth(addWeeks(currentMonth, 1))
            onChangeWeek(getWeek(addWeeks(currentMonth, 1)))
        } else {
            onChangeMonth(addMonths(currentMonth, 1))
        }
    }
    const handlePrev = () => {
        if (displayWeekCalendar) {
            onChangeMonth(subWeeks(currentMonth, 1))
            onChangeWeek(getWeek(subWeeks(currentMonth, 1)))
        } else {
            onChangeMonth(subMonths(currentMonth, 1))
        }
    }

    const handleToday = () => {
        const today = startOfDay(new Date())

        onChangeMonth(today)
        onChangeWeek(getWeek(today))
        onSelectDate(today)
    }

    const handleChangeCalendarView = (
        event: React.MouseEvent<HTMLElement, MouseEvent>,
        value: boolean | null,
    ) => {
        if (value !== null) {
            onChangeCalendarView(value)
        }
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                width: '100%',
                gap: 1,
                p: isMobile ? '8px 12px' : 2,
                flexWrap: 'wrap',
            }}>
            <Stack
                direction="row"
                alignItems="center"
                sx={{
                    width: '160px',
                    gap: 0.5,
                    flexWrap: 'wrap',
                }}>
                <Typography
                    variant="Header3"
                    sx={{
                        color: '#1B1C1D',
                        textTransform: 'capitalize',
                    }}>
                    {format(currentMonth, 'LLLL', { locale })}
                </Typography>
                <Typography variant="Header3" color="#707274">
                    {format(currentMonth, 'yyyy', { locale })}
                </Typography>
            </Stack>
            <StepperCalendar
                handleNext={handleNext}
                handlePrev={handlePrev}
                handleToday={handleToday}
            />
            {!isMobile && (
                <SwitcherCalendar onChange={handleChangeCalendarView} value={displayWeekCalendar} />
            )}
        </Stack>
    )
}
